module.exports = __webpack_public_path__ + "img/wash-hands.8d503c60.jpg";